/**
 * Canonical phase and turn stage types for the Legendary Arena game engine.
 *
 * These types define the match lifecycle phases and the per-turn stage cycle.
 * All logic, type guards, helpers, and tests must derive behavior from the
 * canonical arrays (MATCH_PHASES, TURN_STAGES) — no hardcoded string literals.
 */
/** All match phases in canonical order. Single source of truth. */
export const MATCH_PHASES = [
    'lobby',
    'setup',
    'play',
    'end',
];
/** All turn stages in canonical order. Single source of truth. */
export const TURN_STAGES = [
    'start',
    'main',
    'cleanup',
];
//# sourceMappingURL=turnPhases.types.js.map